import { BaseEnum } from "../BaseEnum";

export class DsrType extends BaseEnum {
  static EFRAG = 1;
  static MEF = 2;
  static BEFORE_EFRAG_AND_MEF_SPLIT = 99;

  static Codes = [this.EFRAG, this.MEF, this.BEFORE_EFRAG_AND_MEF_SPLIT];
  static _labelKeys = [
    "dsr.EFRAG",
    "dsr.MEF",
    "dsr.BEFORE_EFRAG_AND_MEF_SPLIT",
  ];
}
